module.exports = __webpack_public_path__ + "static/img/bofangluyin2.fcb9195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/bofangluyin2.png
// module id = e60w
// module chunks = 24